import Home from '@/components/home';
import { MainLayout } from '@/root/src/layouts';

const Index = () => {
  return (
    <MainLayout>
      <div className="w-screen h-[100dvh] pt-[63px] box-border flex justify-center">
        <div
          className={
            'md:max-w-[800px] lg:max-w-[1440px] box-border w-full overflow-y-auto'
          }
        >
          <Home />
        </div>
      </div>
    </MainLayout>
  );
};

export default Index;
